import { WishlistTemplatesGridView } from '~/components/catalog/wishlist-templates';
import { PageContainer } from '~/components/page-container';

export function WishlistTemplates() {
	return (
		<PageContainer>
			<WishlistTemplatesGridView />
		</PageContainer>
	);
}
